module.exports = __webpack_public_path__ + "img/mobile-nav-instagram.7bf74276.svg";